import React, { useState, useRef, useEffect } from "react";
import { BiSearch, BiMenu, BiX } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../utils/api";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [isUnsubscribing, setIsUnsubscribing] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const profileRef = useRef(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const prevLoginRef = useRef(false);

 useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  // 🔥 NEW: query se check
  if (params.get("subscribed") === "true") {
    localStorage.setItem("isSubscribed", "true");
  }

  const loggedIn = localStorage.getItem("isSubscribed") === "true";
  setIsLoggedIn(loggedIn);

  if (!prevLoginRef.current && loggedIn) {
    navigate("/play");
  }

  prevLoginRef.current = loggedIn;
}, [location.pathname, navigate]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isActive = (path) => location.pathname === path;

  const getNavLinkClass = (path) =>
    `cursor-pointer text-[18px] transition-all duration-200 ${isActive(path)
      ? "text-red-500 font-semibold"
      : "text-white hover:text-red-500 font-semibold"
    }`;

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setShowProfileMenu(false);
    navigate("/signin");
  };

const handleUnsubscribe = async () => {
  if (isUnsubscribing) return;
  if (!window.confirm("Are you sure you want to unsubscribe? You will lose access immediately.")) return;
  setIsUnsubscribing(true);
  try {
    const response = await api.delete("/subscriptions/unsubscribe");
    console.info("[UNSUB] Subscription cancelled successfully");
    alert(response.data.message || "Your subscription has been cancelled successfully.");
    localStorage.removeItem("isSubscribed");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("subscription");
    localStorage.removeItem("accessToken");
    setIsLoggedIn(false);
    setShowProfileMenu(false);
    setMenuOpen(false);
    navigate("/signin");
  } catch (error) {
    console.error("[UNSUB] Cancellation failed", { status: error.response?.status, message: error.response?.data?.message || error.message });
    alert(error.response?.data?.message || "Unable to cancel your subscription right now. Please try again later.");
  } finally {
    setIsUnsubscribing(false);
  }
};

  const navAndClose = (path) => {
    setMenuOpen(false);
    setShowSearch(false);
    navigate(path);
  };

  return (
    <header className="w-full z-[9999] absolute top-0 left-0">
      <nav className="max-w-7xl mx-auto px-6 py-4 relative bg-transparent">
        <div className="flex items-center justify-between">

          {/* Logo */}
          <div
            onClick={() => {
              setMenuOpen(false);
              setShowSearch(false);
              navigate("/");
            }}
            className="cursor-pointer"
          >
            <img src="/assets/newghana.png" className="h-24 w-auto" alt="logo" />
          </div>

          {/* Desktop Nav */}
          <ul className="hidden md:flex items-center space-x-9">
            <li onClick={() => navAndClose("/")} className={getNavLinkClass("/")}>Home</li>

            {!isLoggedIn ? (
              <li onClick={() => navAndClose("/games")} className={getNavLinkClass("/games")}>Games</li>
            ) : (
              <li onClick={() => navAndClose("/play")} className={getNavLinkClass("/play")}>Play</li>
            )}

    
            <li onClick={() => navAndClose("/video")} className={getNavLinkClass("/video")}>Videos</li>
            <li onClick={() => navAndClose("/support")} className={getNavLinkClass("/support")}>Support</li>
          </ul>

          {/* Right Section */}
          <div className="flex items-center gap-4">

            {/* Search */}
            <div className="hidden md:flex items-center gap-2">
              <div
                className={`flex items-center gap-2 transition-all duration-300 ${showSearch ? "w-72 opacity-100" : "w-0 opacity-0 overflow-hidden"
                  }`}
              >
                <input
                  className="w-full p-2 rounded-xl bg-gray-200 text-black outline-none"
                  type="search"
                  placeholder="Enter keyword"
                />
                <button className="px-4 py-2 rounded-xl bg-red-500 text-white font-semibold">
                  Search
                </button>
              </div>

              <button
                onClick={() => setShowSearch(!showSearch)}
                className="text-white hover:text-red-500"
              >
                {showSearch ? <BiX size={24} /> : <BiSearch size={24} />}
              </button>
            </div>

            {/* LOGIN / PROFILE */}
            {!isLoggedIn ? (
              <button
                onClick={() => navigate("/signin")}
                className="hidden md:block text-[18px] text-white font-semibold hover:text-red-500"
              >
                Subscribe
              </button>
            ) : (
              <div className="relative" ref={profileRef}>
                <div
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  className="w-10 h-10 rounded-full overflow-hidden border-2 border-red-500 cursor-pointer"
                >
                  <img
  src={localStorage.getItem("selectedAvatar") || "/assets/game-banner-illus-4.webp"}
  alt="profile"
/>
                </div>

                {showProfileMenu && (
  <div className="absolute right-0 mt-3 w-80 bg-[#2f3045] text-white rounded-2xl shadow-xl overflow-hidden">

    <div className="text-center py-4 border-b border-[#ffffff10]">
      <h2 className="text-xl font-bold">Hello</h2>
    </div>

    <div className="flex items-center justify-between px-5 py-3 hover:bg-[#ffffff10] cursor-pointer">
      <div className="flex items-center gap-3">
        <span>👤</span>

        <button
          onClick={() => navigate("/myaccount")}
          className="font-semibold"
        >
          My Account
        </button>
      </div>

      <span className="text-yellow-400">→</span>
    </div>

    <div className="flex border-t border-[#ffffff10]">

      <button
        onClick={handleUnsubscribe}
        className="w-1/2 py-4 text-yellow-400 font-semibold hover:bg-[#ffffff10]"
      >
        {isUnsubscribing ? "Cancelling..." : "Unsubscribe"}
      </button>

      <button
        onClick={handleLogout}
        className="w-1/2 py-4 text-gray-300 font-semibold hover:bg-[#ffffff10] hover:text-white"
      >
        ⦿ Sign Out
      </button>

    </div>

  </div>
)}
              </div>
            )}

            {/* Mobile Menu Button */}
            <button
              className="md:hidden text-red-500"
              onClick={() => {
                setMenuOpen(!menuOpen);
                setShowSearch(false);
              }}
            >
              {menuOpen ? <BiX size={28} /> : <BiMenu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden mt-3 w-full bg-white rounded-xl shadow-md">
            <ul className="flex flex-col gap-4 px-4 py-4 text-black">
              <li onClick={() => navAndClose("/")} className="cursor-pointer">Home</li>
              {!isLoggedIn ? (
  <li onClick={() => navAndClose("/games")} className="cursor-pointer">
    Games
  </li>
) : (
  <li onClick={() => navAndClose("/play")} className="cursor-pointer">
    Play
  </li>
)}
              <li onClick={() => navAndClose("/video")} className="cursor-pointer">Videos</li>
              <li onClick={() => navAndClose("/support")} className="cursor-pointer">Support</li>

              {/* ✅ ADD THIS */}
              {/* MOBILE LOGIN / PROFILE */}

{!isLoggedIn ? (
  <button
    onClick={() => navAndClose("/signin")}
    className="bg-red-500 text-white font-semibold py-2 rounded-lg"
  >
    Subscribe
  </button>
) : (
  <div className="flex flex-col gap-3 border-t pt-3">

    {/* Profile */}
    <div className="flex items-center gap-3">
      <img
        src={
          localStorage.getItem("selectedAvatar") ||
          "/assets/game-banner-illus-4.webp"
        }
        alt="profile"
        className="w-12 h-12 rounded-full border-2 border-red-500"
      />

      <div>
        <h3 className="font-bold text-black">Hello User</h3>
        <p className="text-sm text-gray-500">Subscribed User</p>
      </div>
    </div>

    {/* My Account */}
    <button
      onClick={() => navAndClose("/myaccount")}
      className="bg-gray-100 py-2 rounded-lg font-semibold"
    >
      My Account
    </button>

    {/* Play */}
    <button
      onClick={() => navAndClose("/play")}
      className="bg-gray-100 py-2 rounded-lg font-semibold"
    >
      Play
    </button>

    {/* Unsubscribe */}
    <button
      onClick={handleUnsubscribe}
      className="bg-yellow-400 py-2 rounded-lg font-semibold text-black"
    >
      {isUnsubscribing ? "Cancelling..." : "Unsubscribe"}
    </button>

    {/* Logout */}
    <button
      onClick={handleLogout}
      className="bg-red-500 text-white py-2 rounded-lg font-semibold"
    >
      Sign Out
    </button>

  </div>
)}
            </ul>
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;
